import { Form as AForm } from 'ant-design-vue/es/components';
import { ref, useSlots } from 'vue';
const isNumberKey = evt => {
  const charCode = evt.which ? evt.which : evt.keyCode;
  const value = evt.target.value;
  // 如果输入的是数字，或者是小数点，且小数点只能有一个
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    return false;
  } else {
    // 检查是否已经输入了小数点
    const dot = String.fromCharCode(46); // 小数点的字符代码
    const index = value.indexOf(dot);
    // 如果已经输入小数点，后面就不能输入小数点和负号
    if (index > -1 && (charCode === 46 || charCode === 45)) {
      return false;
    }
    // 如果第一个字符是负号，只能接受小数点
    return !(value.length === 1 && value === '-' && charCode !== 46);
  }
};
const filterNumber = value => {
  // 保存输入的当前值
  let currentValue = value;
  // 正则表达式，匹配数字和小数点
  const regex = /^\d*(\.\d*)?$/;
  // 如果当前值不符合条件，则将输入值设置为上一个有效值
  if (!regex.test(currentValue)) {
    currentValue = currentValue.replace(/[^0-9.]/g, '');
  }
  return currentValue;
};
export default {
  name: 'NumberEditor',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: ''
    },
    max: {
      type: Number,
      default: undefined
    },
    min: {
      type: Number,
      default: 0
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:value', 'blur', 'focus'],
  setup(props, context) {
    const formItemContext = AForm.useInjectFormItemContext();
    const isFocused = ref(false);
    const slots = useSlots();
    const handleBLur = e => {
      isFocused.value = false;
      context.emit('blur', e);
      formItemContext.onFieldBlur();
    };
    const handleFocus = e => {
      context.emit('focus', e);
      isFocused.value = true;
    };
    const handleUpdateValue = v => {
      const val = filterNumber(v);
      let n = parseFloat(val);
      if (Number.isNaN(n)) {
        n = 0;
      }
      if (typeof props.max === 'number' && !Number.isNaN(props.max)) {
        if (n > props.max) {
          n = props.max;
        }
      }
      if (typeof props.min === 'number' && !Number.isNaN(props.min)) {
        if (n < props.min) {
          n = props.min;
        }
      }
      context.emit('update:value', n);
      formItemContext.onFieldChange();
    };
    const handleKeyPress = e => {
      return isNumberKey(e);
    };
    const handleInput = e => {
      e.target.value = filterNumber(e.target.value);
    };
    return {
      isFocused,
      slots,
      handleBLur,
      handleFocus,
      handleUpdateValue,
      handleKeyPress,
      handleInput
    };
  }
};